// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"bc81d69b-168":"f5c78f442215d4f766c8","bc81d69b-452":"a92085acf716ef75988a","bc81d69b-379":"1ea301f57908b89e2312","bc81d69b-83":"fa7868ff05f881fcc789"}[chunkId] + ".js";
};